// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"TQ-z","upvoteIcon":"UQ-z","downvoteIcon":"VQ-z","feedbackIcon":"WQ-z"};